export default __webpack_public_path__ + "cfe3356d66847f61c15e6a8cb27928dd.svg";